import { render, staticRenderFns } from "./matrixcell.vue?vue&type=template&id=3ca54ee5&"
import script from "./matrixcell.vue?vue&type=script&lang=ts&"
export * from "./matrixcell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ca54ee5')) {
      api.createRecord('3ca54ee5', component.options)
    } else {
      api.reload('3ca54ee5', component.options)
    }
    module.hot.accept("./matrixcell.vue?vue&type=template&id=3ca54ee5&", function () {
      api.rerender('3ca54ee5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/matrixcell.vue"
export default component.exports